export const ARCHE_ID = 'arche_fias_leads';
export const ARCHE_PATH = `/a/${ARCHE_ID}`;
